import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, hexToHsl, BRAND_KEY, setSessionActive } from "@/lib/api";
import { getLang, initI18n, setLang } from "@/lib/i18n";

initI18n();

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [settings, setSettings] = useState(null);

  const loadSettings = useCallback(async (brand) => {
    if (brand) localStorage.setItem(BRAND_KEY, brand.toUpperCase());
    const code = localStorage.getItem(BRAND_KEY);
    try {
      const { data } = await api.get("/public/settings", { params: code ? { code } : {} });
      setSettings(data);
    } catch {
      localStorage.removeItem(BRAND_KEY);
      const { data } = await api.get("/public/settings");
      setSettings(data);
    }
  }, []);

  useEffect(() => {
    if (!window.location.pathname.startsWith("/accesso/")) loadSettings();
    api.get("/auth/me").then((r) => { setSessionActive(true); setUser(r.data); }).catch(() => setUser(null));
  }, [loadSettings]);

  useEffect(() => {
    if (!settings) return;
    const root = document.documentElement;
    const hsl = hexToHsl(settings.primary_color || "#009B77");
    root.style.setProperty("--primary", hsl);
    root.style.setProperty("--ring", hsl);
    document.title = settings.app_name || "Nexora";
    const pref = user?.theme && user.theme !== "system" ? user.theme : settings.default_theme;
    root.classList.toggle("dark", pref === "dark");
  }, [settings, user]);

  useEffect(() => {
    if (user?.id) api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    else if (user === null && !window.location.pathname.startsWith("/accesso/")) loadSettings();
  }, [user?.id, user, loadSettings]);

  useEffect(() => {
    if (user?.language && user.language !== getLang()) setLang(user.language);
  }, [user?.language]);

  const signIn = (u) => {
    setSessionActive(true);
    setUser(u);
  };
  const logout = () => {
    setSessionActive(false);
    api.post("/auth/logout").catch(() => {});
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, settings, setSettings, loadSettings, signIn, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
